import { apiPost, apiStore } from '../../../modules/apiHelper';
import {
  isStaleData, now, toBoolean, urlFriendly,
} from '../../../modules/dataHelper';

export default {
  async getMenteeTasks(context, menteeId) {
    const formData = new FormData();
    formData.set('userid', menteeId);

    const goals = await context.dispatch('getGoals', []);

    return apiPost('task_list', formData, 1)
      .catch((err) => {
        console.warn('Error in getting sub goals check. \n', err);
      })
      .then((res) => {
        if (!res) return [];
        if (toBoolean(res.data.error)) {
          console.warn('Error in getting sub goals check. \n', res.data.message);
          return [];
        }

        const tasks = res.data.goals_check || [];

        const mappedTasks = tasks.map((task) => {
          // eslint-disable-next-line eqeqeq
          const taskGoal = goals.find((goal) => goal.id == task.subgoalid);

          return {
            ...task,
            goal: taskGoal || {},
          };
        });

        return mappedTasks;
      });
  },

  async createTask(context, [userId, formData, resources = [], linkResources = []]) {
    const task = await apiPost('create_tasks', formData, 1)
      .catch((err) => {
        console.warn('Error in creating task \n', err);
        return false;
      })
      .then(async (res) => {
        if (!res) return false;
        if (toBoolean(res.data.error)) return false;

        return res.data;
      });

    let taskResources = [true, 100];
    if (task && task.taskid) {
      taskResources = await context.dispatch('uploadTaskResource', [task.taskid, resources, linkResources]);
    }

    if (task) {
      await Promise.all([
        context.dispatch('clearReferencedItem', `draftTask/${userId}`),
        context.dispatch('clearReferencedItem', `CreateTaskRefResources/${userId}`),
        context.dispatch('clearReferencedItem', `CreateTaskRefLinkResources/${userId}`),
      ]);
    }

    return [task, ...taskResources];
  },

  async getTaskDraft(context, userId) {
    const [expiry, draft] = await apiStore.getItem(`draftTask/${userId}`) || [0, [undefined, undefined, undefined, undefined]];

    // expiry of 12 hours
    if (isStaleData(expiry, now(), 43200000)) {
      await apiStore.removeItem(`draftTask/${userId}`);
      return [undefined, undefined, undefined, undefined];
    }

    return draft;
  },

  async getCreateTaskReferencedItem(context, refId) {
    const refItem = await apiStore.getItem(refId);
    return refItem;
  },

  async saveCreateTaskDraft(context, [refId, draftData]) {
    const refItem = await apiStore.setItem(`draftTask/${refId}`, [now(), draftData]);
    return refItem;
  },

  async approveTaskReport(context, taskId) {
    const formData = new FormData();
    formData.set('taskid', taskId);

    const response = await apiPost('mark_task_complete', formData, 1)
      .catch((err) => {
        console.warn('acceptTaskReport', err);
        return false;
      })
      .then(async (res) => {
        if (!res) return false;
        if (toBoolean(res.data.error)) return false;

        // get the updated task Details
        context.dispatch('getProgramTask', [taskId, true]);

        return true;
      });

    return response;
  },

  async rejectTaskReport(context, taskId) {
    const formData = new FormData();
    formData.set('taskid', taskId);

    const response = await apiPost('reject_task_report', formData, 1)
      .catch((err) => {
        console.warn('rejectTaskReport', err);
        return false;
      })
      .then(async (res) => {
        if (!res) return false;
        if (toBoolean(res.data.error)) return false;

        // get the updated task Details
        context.dispatch('getTask', [taskId, true]);

        return true;
      });

    return response;
  },

  async revertTask(context, [taskId, resources, reportText]) {
    const requests = [];
    const percentagesComplete = [];

    const arrayedResources = Array.from(resources);

    arrayedResources.forEach((resource, index) => {
      const formData = new FormData();
      formData.set('taskid', taskId);
      formData.set('name', resource.name);
      formData.append('file1', resource, urlFriendly(resource.name));

      requests.push(apiPost(
        'reject_task_report',
        formData,
        1,
        {
          'Content-Type': 'multipart/form-data',
        },
        (progressEvent) => {
          percentagesComplete[index] = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
      ));
      //
    });

    if (reportText.length) {
      const formData = new FormData();
      formData.set('taskid', taskId);
      formData.set('review', reportText);
      formData.set('text', arrayedResources.length ? 2 : 1);

      requests.push(apiPost('reject_task_report', formData, 1));
    }

    const response = Promise.all(requests)
      .catch((err) => {
        console.warn('revertTask failed!', err);
      })
      .then((res) => {
        if (!res) return false;
        const positive = res.every((r) => !!r);
        if (!positive) return false;
        const haveErrors = res.every((r) => toBoolean(r.data.error));
        if (haveErrors) return false;

        return true;
      });

    return [response, percentagesComplete];
  },
};
